module.exports = __webpack_public_path__ + "img/516-911723.png";